import React from "react";
import { IGroupMemberStats, IInfoTeamPlayers } from "@grassrootly/api/entities";
import { ImageBackground, View } from "react-native";
import { images } from "../../../../layout/assets";
import { Div, Label, Touchable } from "@grassrootly/rn-core";
import { PlayerRating } from "../../../shared";
import { Image } from "react-native";
import { NavigationProp } from "@react-navigation/native";
import { MainStackParamList } from "../../../../navigation/Navigation.types";

export interface GroupTopTeamProps {
  loadingInfoPlayers: boolean;
  infoPlayers: IInfoTeamPlayers[] | [] | IGroupMemberStats[];
  noDataMessage?: string;
  navigation?: NavigationProp<MainStackParamList>;
}

export const GroupTopTeam: React.FC<GroupTopTeamProps> = ({ loadingInfoPlayers, infoPlayers, noDataMessage, navigation }) => {
  return (
    <>
      {!loadingInfoPlayers && !infoPlayers.length && (
        <Label type="l2Regular" classNames={["textCenter", "colorSecondaryLight", "mt-{5}"]}>
          {noDataMessage ?? "Hey, there was no matches played in this month. Here you will be able to see your top team, just play one game at least ☺"}
        </Label>
      )}
      {!!infoPlayers && !!infoPlayers.length && <ImageBackground source={images.footballFieldBg} resizeMode="cover" style={{ flex: 1, minHeight: 290 }}>
        <View style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.45)" }} />
        {!loadingInfoPlayers && infoPlayers && (!Array.isArray(infoPlayers) || infoPlayers.length === 0) ? (
          <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight", "mt-{30}"]}>
            Info players not found
          </Label>
        ) : null}

        <>
          {!loadingInfoPlayers && infoPlayers && (
            <Div classNames={["alignItemsCenter", "flexRow", "flex1"]}>
              {infoPlayers ? (
                <Div classNames={["flexRow", "flex1", "justifyContentSpaceAround"]}>
                  {/* Left column */}
                  <Div classNames={["gap16"]}>
                    {infoPlayers.slice(0, 3).map((item, index: number) => (
                      <Touchable
                        key={`${item.name}-${index}`}
                        onPress={item && (item as any).player_id ? () => navigation?.navigate("eqipa-card", { playerId: (item as any).player_id }) : undefined}
                        disabled={!(item && (item as any).player_id)}
                      >
                        <Div classNames={["gap8", "alignItemsCenter"]}>
                          <Div classNames={["gap8", "alignItemsCenter", "flexRow"]}>
                            <Image
                              style={{ height: 50, width: 50, borderRadius: 40 }}
                              resizeMode="cover"
                              source={item.profile_picture ? { uri: item.profile_picture } : images.playerAvatar}
                            />
                            {typeof item.avg_rating == "number" ? (
                              <PlayerRating rating={item.avg_rating} classNames={["p8"]} />
                            ) : null}
                          </Div>
                          <Label type="l2Regular">{item.name}</Label>
                        </Div>
                      </Touchable>
                    ))}
                  </Div>
                  {/* Right column */}
                  <Div classNames={["gap16"]}>
                    {infoPlayers.slice(3, 6).map((item, index: number) => (
                      <Touchable
                        key={`${item.name}-${index}`}
                        onPress={item && (item as any).player_id ? () => navigation?.navigate("eqipa-card", { playerId: (item as any).player_id }) : undefined}
                        disabled={!(item && (item as any).player_id)}
                      >
                        <Div classNames={["gap8", "alignItemsCenter"]}>
                          <Div classNames={["gap8", "alignItemsCenter", "flexRow"]}>
                            <Image
                              style={{ height: 50, width: 50, borderRadius: 40 }}
                              resizeMode="cover"
                              source={item.profile_picture ? { uri: item.profile_picture } : images.playerAvatar}
                            />
                            {typeof item.avg_rating == "number" ? (
                              <PlayerRating rating={item.avg_rating} classNames={["p8"]} />
                            ) : null}
                          </Div>
                          <Label type="l2Regular">{item.name}</Label>
                        </Div>
                      </Touchable>
                    ))}
                  </Div>
                </Div>
              ) : null}
            </Div>
          )}
        </>
      </ImageBackground>}
    </>
  );
};
